import { render, staticRenderFns } from "./PT160ChangePassword.vue?vue&type=template&id=89f9cb2c&"
import script from "./PT160ChangePassword.vue?vue&type=script&lang=js&"
export * from "./PT160ChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports